import * as R from 'ramda'
import {
    FETCH_SETTINGS_SUCCESS,
    ADD_SETTINGS_SUCCESS
} from '../actionTypes'

const InitialState = {

};

export default (state = InitialState, {type, payload}) => {

    switch (type) {
        case FETCH_SETTINGS_SUCCESS:
            return payload
        case ADD_SETTINGS_SUCCESS:
            return {...state, [payload.label] : payload.val}

        default:
            return state
    }
}


// WEBPACK FOOTER //
// ./src/reducers/settings.js